module.exports = __webpack_public_path__ + "static/media/Meditation.f082edb1.png";